import http from "../http";
import { featureFlags } from "@/config/env";
import mockManager from "../mock";

export interface FeedbackRequest {
  content: string;
}

export interface FeedbackResponse {
  code: number; // 状态码：200-成功，201-失败，2001-未登录/登录失效
  message: string; // 提示信息
  data?: any; // 响应数据（可选）
}

export const feedbackApi = {
  // 提交意见反馈
  async submit(payload: FeedbackRequest): Promise<FeedbackResponse> {
    console.log("=== 意见反馈API请求 ===");
    console.log("请求时间:", new Date().toLocaleString("zh-CN"));
    console.log("请求参数:", JSON.stringify(payload, null, 2));

    try {
      // 根据环境变量决定使用mock还是真实API
      if (featureFlags.enableMock) {
        // 使用mock数据
        const response = await mockManager.submitFeedback(payload);
        console.log("=== 意见反馈API响应 (Mock) ===");
        console.log("响应时间:", new Date().toLocaleString("zh-CN"));
        console.log("响应数据:", JSON.stringify(response, null, 2));
        return response;
      } else {
        // 真实API调用
        const response = await http.post<FeedbackResponse>(
          "v1/user/feedback",
          payload
        );
        console.log("=== 意见反馈API响应 (Real) ===");
        console.log("响应时间:", new Date().toLocaleString("zh-CN"));
        console.log("响应数据:", JSON.stringify(response.data, null, 2));
        return response.data;
      }
    } catch (error: any) {
      console.log("=== 意见反馈API错误 ===");
      console.log("错误时间:", new Date().toLocaleString("zh-CN"));
      console.log(
        "错误信息:",
        error?.response?.data || error?.message || error
      );
      throw error;
    }
  },
};
